// extracted by mini-css-extract-plugin
export default {"MMAIwrapper":"Message_MMAIwrapper__BPhmf","MMAImessage":"Message_MMAImessage__zApsn","MMAIleftAlign":"Message_MMAIleftAlign__x3Q1q","MMAIrightAlign":"Message_MMAIrightAlign__Lu17G"};